import { flow, getRoot } from 'mobx-state-tree';

import { logger } from '@lusha/client-logger';

import { fetchUgcData, fetchUgcSettings, sendUserAnswer, updateUgcSettings } from '../../../API/ugcApi';

const Actions = self => ({

  fetchUgcUserSettings: flow(function* fetchUgcUserSettings() {
    const { user: { id } } = getRoot(self);
    self.isLoaded = false;
    try {
      const settings = yield fetchUgcSettings(`userId=${id}`);
      self.invalidAnswers = !settings[0] ? 0 : settings[0]?.invalidAnswers;
      self.isValid = (!settings?.[0] || settings[0]?.invalidAnswers < 2);
      if (self.isValid) {
        yield self.fetchUserUgcData(id);
      }
      self.isLoaded = true;
    } catch (e) {
      logger.warn('failed to fetch UgcSettings');
    }
  }),

  checkForInvalidAnswer: flow(function* checkForInvalidAnswer(key, feedback) {
    if (self.currentContact[key]?.feedback && !feedback) {
      self.setAlreadyAnswered(self.currentContact?.contactId);

      if (self.alreadyAnswered) {
        const { user: { id } } = getRoot(self);
        yield self.updateInvalidAnswers(id, self.currentContact?.contactId);
        yield fetchUgcSettings();
      }
    }
  }),

  sendUserFeedback: flow(function* sendUserFeedback(data) {
    try {
      yield sendUserAnswer(data);
      yield self.fetchUgcUserSettings();
    } catch (e) {
      logger.warn('failed to send user answer');
    }
  }),

  setShouldShowPopup(value) {
    self.shouldShowPopup = value;
  },

  setShouldCheckDismissLogicOrValid(value) {
    self.shouldCheckDismissLogicOrValid = value;
  },

  updateInvalidAnswers: flow(function* updateInvalidAnswers(id, contactId) {
    const updatedInvalidAnswers = self.invalidAnswers + 1;
    try {
      const patchData = {
        userId: id,
        invalidAnswers: updatedInvalidAnswers,
        contactId,
      };
      const promises = [];
      promises.push(updateUgcSettings(id, patchData));
      promises.push(self.fetchUgcUserSettings());
      yield Promise.all(promises);
    } catch (e) {
      logger.warn('failed to update ugcData');
    }
  }),

  fetchUserUgcData: flow(function* fetchUserUgcData(userId) {
    try {
      const query = `userId=${userId}`;
      const data = yield fetchUgcData(query);
      self.userAnswers = data?.map(answer => answer?.contactId);
      self.numOfAnswers = data.length || 0;
    } catch (e) {
      logger.warn('failed to fetch ugc data');
    }
  }),

  setAlreadyAnswered(contactId) {
    for (const answerId of self.userAnswers) {
      if (answerId === contactId) {
        self.alreadyAnswered = true;
      }
    }
  },

  setCurrentContact(contact) {
    self.currentContact = contact.id;
  },

});

export default Actions;
